import { driftGameConnection } from '../driftConnection';
import { driftBetsStore } from '../driftStore/betStore';
import { betStatus, DRIFT_DEFAULT_TIMER_VALUE } from '../driftCore/constants';
import { ValidationType } from '../../../core/constants/validationType';
import { userInfoStore } from '../../../store/userInfoStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { worker } from '../../../index';
import { driftGameStore } from '../driftStore/gameStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { DriftSoundNames } from '../driftCore/constants/sounds';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { notificationStore } from '../../../store/notificationStore';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { driftDrawerService } from './gameDrawerService';
import { freeBetStore } from '../../../store/freeBetStore';

class DriftGameService {
  reportInterval = null;

  onGetInitialStateResult({ spinInfo, additionalInfo }) {
    this.handleResetInitData();
    driftGameConnection.sendCashOut();
    if (spinInfo) {
      driftGameStore.setIsBetButtonDisabled(false); // TODO open comments when backend's done
      setTimeout(() => {
        userInfoStore.getBalance();
      }, 3500);
    }
    if (additionalInfo) {
      checkHashStore.setLastRoundInfo({
        ...additionalInfo,
      });
      checkHashStore.setLastRoundResult({
        roundId: additionalInfo.id,
        roundData: additionalInfo.cashOutOdd,
        date: additionalInfo.time,
      });
    }
    setTimeout(() => {
      userInfoStore.getBalance();
    }, 3500);
  }

  handleResultReportResult(result) {
    this.sendResultReport();
    if (result.responseCode === ValidationType.Success) {
      if (result.freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(result.freebetInfo);
      }
      const { additionalInfo, odd, spinId, hash } = result;
      this.sendWorker(null);
      this.sendWorker(DRIFT_DEFAULT_TIMER_VALUE);
      driftBetsStore.setRoundResult(result);
      driftBetsStore.setWinAmount(result.winAmount);
      if (!driftGameStore.isHeldButton && result.status === betStatus.onHold) {
        this.cancelInvoke(true);
      }
      if (result.status === betStatus.lose) {
        this.cancelInvoke();
        checkHashStore.setLastRoundInfo({
          ...additionalInfo,
        });
        checkHashStore.setLastRoundResult({
          roundData: odd,
          roundId: spinId,
        });
        checkHashStore.setNextRoundHash(hash);

        setTimeout(() => {
          soundService.stop(DriftSoundNames.Drift);
          soundService.stop(DriftSoundNames.Timer);
        }, 1000); // in case if it didn't make it

        driftBetsStore.updateLastResults(result);
        driftBetsStore.setRoundResult(null);
        betHistoryStore.getLastBet();

        driftGameStore.setIsAllowedNextReportInvoke(false);
        driftGameStore.setIsBetButtonDisabled(true);
        driftGameStore.setIsHeldButton(false);
        driftGameStore.setIsOnceClicked(false);
        driftGameStore.setIsDoSpinState(true);

        driftGameStore.setTimer(DRIFT_DEFAULT_TIMER_VALUE);
        this.sendWorker(null);

        driftGameStore.setIsLose(true);
        driftGameStore.setIsHideWin(false);
        setTimeout(() => {
          driftBetsStore.setWinAmount(null);
          driftGameStore.setIsLose(false);
          driftGameStore.setIsHideWin(true);
        }, 1000);
        driftDrawerService.resetRider();
        driftDrawerService.playRiderLose(() => {
          driftDrawerService.resetRider();
          driftDrawerService.playRiderIdleDefault();
          driftGameStore.setIsBetButtonDisabled(false);
        });
        setTimeout(() => {
          this.resetGameState();
        }, 1000);
        return null;
      }
      driftGameStore.setIsAllowedNextReportInvoke(true);
      return null;
    }
    notificationStore.setNotification(result.responseCode);
    return this.cancelInvoke();
  }

  handleDoSpinResult(result) {
    if (result.responseCode === ValidationType.Success) {
      if (result.freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(result.freebetInfo);
      }
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(result.balance);
      }
      userInfoStore.getBalance();
      const { winAmount } = result;
      driftBetsStore.setWinAmount(winAmount);
      if (!driftGameStore.isHeldButton) {
        this.cancelInvoke(true);
      }
      this.sendWorker(null); // removes listener
      this.sendWorker(DRIFT_DEFAULT_TIMER_VALUE); // adds listener
      driftGameStore.setTimerAnimationDelay(0);
      driftGameStore.setIsAllowedNextReportInvoke(true);
      if (result.status !== betStatus.onHold) {
        this.cancelInvoke(true);

        driftGameStore.setIsDoSpinState(true);
        driftGameStore.setIsBetButtonDisabled(true);
        driftGameStore.setIsOnceClicked(false);

        setTimeout(() => {
          soundService.stop(DriftSoundNames.Drift);
          soundService.stop(DriftSoundNames.Timer);
        }, 1000); // in case if it didn't make it

        driftBetsStore.setRoundResult(null);
        driftBetsStore.updateLastResults(result);
        betHistoryStore.getLastBet();

        driftGameStore.setTimer(DRIFT_DEFAULT_TIMER_VALUE);
        this.sendWorker(null);

        driftGameStore.setIsHeldButton(false);
        checkHashStore.setLastRoundInfo({
          ...result.additionalInfo,
        });

        checkHashStore.setLastRoundResult({
          roundData: result.odd,
          roundId: result.spinId,
        });

        checkHashStore.setNextRoundHash(result.hash);

        driftGameStore.setIsLose(true);
        driftGameStore.setIsHideWin(false);
        setTimeout(() => {
          driftBetsStore.setWinAmount(null);
          driftGameStore.setIsLose(false);
          driftGameStore.setIsHideWin(true);
        }, 1000);
        driftDrawerService.playRiderLose(() => {
          driftDrawerService.resetRider();
          this.cancelInvoke();
          driftDrawerService.playRiderIdleDefault();
          driftGameStore.setIsBetButtonDisabled(false);
        });
      } else {
        driftBetsStore.setRoundResult(result);
        if (driftGameStore.isHeldButton) {
          this.sendResultReport();
        }
      }
      return null;
    }
    this.resetGameState();
    driftGameStore.setIsDoSpinState(true);
    this.cancelInvoke();
    if (result.responseCode === ValidationType.InvalidSpinResult) {
      mainGameConnection.stop();
      soundService.stopAll();
      mainGameConnection.socketRecursiveReconnecting(true);
    }
    notificationStore.setNotification(result.responseCode);
    return null;
  }

  invoke() {
    driftDrawerService.resetRider();

    if (!driftGameStore.isDoSpinState && driftBetsStore.roundResult) {
      driftDrawerService.playRiderIdle();
      driftDrawerService.playSmokeIdle();
      this.sendResultReport();
      return;
    }

    driftGameStore.setIsAllowCashOut(true);
    driftDrawerService.playRiderBet();
    driftDrawerService.playSmokeBet(() => {
      driftDrawerService.resetSmoke();
      driftDrawerService.playSmokeIdle();
      driftDrawerService.playRiderIdle();
    });
    if (driftGameStore.isDoSpinState) {
      this.sendDoSpin();
    }
  }

  sendDoSpin() {
    driftGameStore.setIsDoSpinState(false);
    return mainGameConnection.doSpin({ amount: userInfoStore.betAmount });
  }

  sendResultReport() {
    this.reportInterval = setTimeout(() => {
      if (driftGameStore.isAllowedNextReportInvoke) {
        soundService.stop(DriftSoundNames.Timer);
        driftGameStore.setIsAllowedNextReportInvoke(false);
        driftGameConnection.sendResultReport();
      }
    }, 50);
  }

  handleCashOutResult(result) {
    driftGameStore.setIsAllowCashOut(true);
    if (result.responseCode === ValidationType.InvalidSpin) {
      return null;
    }
    if (result.freebetInfo !== null) {
      freeBetStore.updateCurrentFreeBet(result.freebetInfo);
    }

    if (result.responseCode !== ValidationType.Success) {
      setTimeout(() => {
        driftGameStore.setIsShowCashOut(false);
        driftBetsStore.setWinAmount(null);
      }, 1000);
      this.resetGameState();
      if (result.responseCode !== ValidationType.SpinNotFound) {
        notificationStore.setNotification(result.responseCode);
      }
      return null;
    }

    const { additionalInfo, hash, spinId, odd } = result;

    setTimeout(() => {
      soundService.stop(DriftSoundNames.Drift);
      soundService.stop(DriftSoundNames.Timer);
    }, 1000); // in case if it didn't make it

    driftGameStore.setIsDoSpinState(true);
    driftGameStore.setIsOnceClicked(false);
    betHistoryStore.getLastBet();

    checkHashStore.setNextRoundHash(hash);
    checkHashStore.setLastRoundInfo({
      ...additionalInfo,
    });
    checkHashStore.setLastRoundResult({
      roundId: spinId,
      roundData: odd,
    });

    this.sendWorker(null);
    driftGameStore.setTimer(DRIFT_DEFAULT_TIMER_VALUE);
    driftBetsStore.updateLastResults(result);
    driftBetsStore.setRoundResult(null);
    driftGameStore.setIsWin(true);
    soundService.play(DriftSoundNames.Win);
    driftGameStore.setIsShowCashOut(true);
    setTimeout(() => {
      driftGameStore.setIsHideWin(false);
    }, 500);
    setTimeout(() => {
      driftGameStore.setIsShowCashOut(false);
      driftBetsStore.setWinAmount(null);
      driftGameStore.setIsWin(false);
      driftGameStore.setIsHideWin(true);
      userInfoStore.getBalance();
      driftGameStore.setIsBetButtonDisabled(false);
      driftGameStore.setIsDoSpinState(true);
    }, 1000);

    return null;
  }

  sendCashOut() {
    if (
      !driftGameStore.isLose &&
      driftGameStore.isAllowCashOut &&
      driftBetsStore.roundResult &&
      !driftGameStore.isHeldButton
    ) {
      driftGameStore.setIsAllowCashOut(false);
      driftGameStore.setIsBetButtonDisabled(true);
      return driftGameConnection.sendCashOut();
    }
    return null;
  }

  cancelInvoke(force = false) {
    if (this.reportInterval || force) {
      clearInterval(this.reportInterval);
      soundService.stop(DriftSoundNames.Drift);
      driftDrawerService.resetSmoke();
      driftDrawerService.resetRider();
      driftDrawerService.playRiderIdleDefault();
    }
  }

  resetGameState() {
    driftGameStore.setIsWin(false);
    driftGameStore.setIsHideWin(true);
    soundService.stop(DriftSoundNames.Drift);
    driftGameStore.setIsDoSpinState(true);
    clearTimeout(this.reportInterval);
    driftGameStore.setIsOnceClicked(false);
    driftGameStore.setIsBetButtonDisabled(false);
    driftGameStore.setTimer(DRIFT_DEFAULT_TIMER_VALUE);
    driftDrawerService.resetRider();
    driftDrawerService.resetSmoke();
    driftDrawerService.playRiderIdleDefault();
  }

  handleResetInitData() {
    driftBetsStore.setWinAmount(null);
    driftGameStore.setIsLose(false);
    driftGameStore.setIsHideWin(true);
    driftGameStore.setIsOnceClicked(false);
    driftGameStore.setIsBetButtonDisabled(false);
    driftGameStore.setIsHideWin(true);
    driftGameStore.setIsWin(false);
  }

  countDown({ data }) {
    driftGameStore.setTimer(data.timerValue);
  }

  sendWorker(time) {
    if (time) {
      worker.addEventListener('message', this.countDown);
      worker.postMessage({
        timerValue: time,
        deductionValue: 1,
        intervalDelay: 900,
        precision: 0,
      });
    } else {
      worker.removeEventListener('message', this.countDown);
    }
  }
}

export const driftGameService = new DriftGameService();
